/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Spotting_Event_Group_LabelInputs */

const en_ccsl_export_spotting_event_group_label = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spotting List Event Group`)
};

const fr_ccsl_export_spotting_event_group_label = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'evenements de la liste de reperage`)
};

const de_ccsl_export_spotting_event_group_label = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsgruppe „Spotting List“`)
};

const it_ccsl_export_spotting_event_group_label = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di eventi della lista di avvistamento`)
};

const ru_ccsl_export_spotting_event_group_label = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа мероприятий «Список наблюдений»`)
};

const es_ccsl_export_spotting_event_group_label = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos de lista de avistamiento`)
};

const zh_cn2_ccsl_export_spotting_event_group_label = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`观测列表活动组`)
};

const ja_ccsl_export_spotting_event_group_label = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スポッティングリストイベントグループ`)
};

const hi_ccsl_export_spotting_event_group_label = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पॉटिंग लिस्ट इवेंट ग्रुप`)
};

const pt_pt2_ccsl_export_spotting_event_group_label = /** @type {(inputs: Ccsl_Export_Spotting_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Eventos da Lista de Observação`)
};

/**
* | output |
* | --- |
* | "Spotting List Event Group" |
*
* @param {Ccsl_Export_Spotting_Event_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_spotting_event_group_label = /** @type {((inputs?: Ccsl_Export_Spotting_Event_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Spotting_Event_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_spotting_event_group_label(inputs)
	if (locale === "de") return de_ccsl_export_spotting_event_group_label(inputs)
	if (locale === "it") return it_ccsl_export_spotting_event_group_label(inputs)
	if (locale === "ru") return ru_ccsl_export_spotting_event_group_label(inputs)
	if (locale === "es") return es_ccsl_export_spotting_event_group_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_spotting_event_group_label(inputs)
	if (locale === "ja") return ja_ccsl_export_spotting_event_group_label(inputs)
	if (locale === "hi") return hi_ccsl_export_spotting_event_group_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_spotting_event_group_label(inputs)
	return en_ccsl_export_spotting_event_group_label(inputs)
});